<template>
	<div class="row">
		<div class="col-12">{{ horario }}</div>
		<div class="col-12">
			<div v-if="status == 'EM_ANALISE'">
				<div class="mb-2">
					<LoadingStatus :texto="'Seu atendimento está em análise'" />
				</div>
			</div>

			<div v-if="status == 'SEM_ORIGEM'">
				<div class="mb-2">Sem endereço de origem</div>
				<div class="text-center">
					<BotaoUsarLocalizacao :tipoEndereco="'Origem'" />
				</div>
			</div>

			<div v-if="status == 'SEM_DESTINO'">
				<div class="mb-2">Sem endereço de destino</div>
				<div class="text-center">
					<BotaoUsarLocalizacao :tipoEndereco="'Destino'" />
				</div>
			</div>

			<div v-else-if="status == 'BUSCANDO_PRESTADOR'">
				<div class="mb-1">
					<LoadingStatus :texto="'Buscando prestador'" />
				</div>
				<div class="lh-18">
					<small>Estamos procurando o prestador ideal para o seu atendimento</small>
				</div>
			</div>

			<div v-else-if="status == 'PRESTADOR_ACIONADO' || (temServicos && status == 'PRESTADOR_A_CAMINHO')">
				<div class="mb-1">Prestador acionado</div>
				<div class="lh-18">
					<small>Agora é só esperar, o prestador está a caminho.</small>
				</div>
			</div>

			<div v-else-if="temServicos &&
				servico.chegadaConfirmadaPor && servico.chegadaConfirmadaPor == 'PRESTADOR' &&
				servico.solicitanteConfirmouChegada !== true &&
				(['PRESTADOR_CHEGOU_LOCAL', 'VIAJANDO_PARA_DESTINO', 'FINALIZADO'].includes(status))
			">
				<div class="mb-1">Prestador chegou ao local</div>
				<div class="lh-18">
					<small>Confirme se o prestador chegou no local de atendimento</small>
				</div>
				<div class="row mt-3">
					<div class="col-6">
						<button class="btn btn-success w-100" @click="confirmarChegada('S')" :disabled="loading">
							<span class="material-symbols-outlined">mood</span> {{ loading ? "Aguarde..." : "Chegou" }}
						</button>
					</div>
					<div class="col-6">
						<button class="btn btn-danger w-100" @click="confirmarChegada('N')" :disabled="loading">
							<span class="material-symbols-outlined">mood_bad</span> {{ loading ? "Aguarde..." : "Não Chegou" }}
						</button>
					</div>
				</div>
			</div>

			<div
				v-else-if="(temServicos && servico.solicitanteConfirmouChegada === true && status == 'VIAJANDO_PARA_DESTINO') || status == 'FINALIZADO'">
				<div class="mb-2">O prestador está indo para o destino</div>
			</div>

			<div v-else-if="status == 'CANCELADO'">
				<div class="mb-2">Este atendimento foi finalizado</div>
			</div>
		</div>
	</div>
</template>

<script setup>

import BotaoUsarLocalizacao from '@/components/Botoes/BotaoUsarLocalizacao.vue';
import LoadingStatus from '@/components/Loadings/LoadingStatus.vue';
import { storeToRefs } from 'pinia';
import { useAtendimentoStore } from '@/stores/atendimento';
import { computed, ref, defineProps } from "vue";
import { toast, alert, confirm } from '@/helper/alerts';

const props = defineProps({
	horario: String,
	status: String,
	servico: Object,
	idServicoAtendimento: String
})

let loading = ref(false);

const store = useAtendimentoStore();
const { totalServicos } = storeToRefs(store);

const temServicos = computed(() => totalServicos.value > 0);

function confirmarChegada(chegou) {
	confirm(
        "",
        `Deseja confirmar que o prestador <b>${chegou == 'S' ? 'chegou' : 'NÃO chegou'}</b>?`,
        async () => {
            try {
				loading.value = true;
				const response = await store.confirmarChegadaPrestador((chegou), props.idServicoAtendimento);
				toast("success", response.message);
			} catch (error) {
				alert("error", "", error.message);
			} finally {
				loading.value = false;
			}
        }
    );
}
</script>


<style>
#icone-status-atual::before {
	content: '';
	position: absolute;
	top: 10px;
	bottom: 0;
	width: 2px;
	background: lightgray;
	left: 46%;
	z-index: -1;
}
</style>
